import Script from "next/script";

/**
 * This code snippet (giN) applies *only* to zapier.com's domain.
 * If you want to test this in another environment, follow these directions:
 * - Go to https://app.qualaroo.com/dashboard (login with 1Pass)
 * - Find the domain you want to test on (zapier.com, zapier-staging.com, localhost)
 * - Find the Code Installed link here https://cdn.zappy.app/00244e431a137f2d84d3937599379de7.png
 * - Find the new code snippet and replace this file with that snippet's code. The `s.src = ...` line should change
 * - Create a survey that loads on a url and verify it works
 **/
export function QualarooCodeSnippet() {
  return (
    <Script id="reporting-qualaroo" strategy="lazyOnload">
      {/* eslint-disable-next-line react/jsx-no-literals -- inline third-party script body, not user-facing copy */}
      {`
        var _kiq = _kiq || [];
        (function(){
          setTimeout(function(){
          var d = document, f = d.getElementsByTagName('script')[0], s = d.createElement('script'); s.type = 'text/javascript';
          s.async = true; s.src = 'https://cl.qualaroo.com/ki.js/68561/giN.js'; f.parentNode.insertBefore(s, f);
          }, 1);
        })();
      `}
    </Script>
  );
}
